export const filterByJobTitle = (position, jobTitle) =>
  jobTitle
    ? position.title.toLowerCase().includes(jobTitle.toLowerCase())
    : true

export const filterByDepartment = (position, department) => {
  if (department === 'all') return true
  return department ? position.department === department : true
}

export const filterByLocation = (position, location) => {
  if (location === 'all') return true
  return location ? position.country === location : true
}

export const filterByDatePosted = (createdAt, datePostedFilter) => {
  if (datePostedFilter === 'all') return true
  if (!createdAt) return false
  const currentDate = new Date()
  const positionDatePosted = new Date(createdAt)

  const dateDifferences = {
    past24Hours: 24 * 60 * 60 * 1000,
    lastWeek: 7 * 24 * 60 * 60 * 1000,
    lastMonth: 30 * 24 * 60 * 60 * 1000,
  }

  return datePostedFilter
    ? currentDate - positionDatePosted <
        (dateDifferences[datePostedFilter] || Infinity)
    : true
}
